module.exports = __webpack_public_path__ + "media/images/worktype_role/mundial-74d16f5ee68a6a82700da4224c97bff7.png";